import {css} from "lit";


export const selectOptionOnDarkStyles = css`
  --_select-option__color: var(--sbkSelectColorFgColorOnLightDefault);
  --_select-option__color--active: var(--sbkSelectColorFgColorOnDarkEnabled);
  --_select-option__color--disabled: var(--sbkSelectColorFgColorOnLightDisabled);

  --_select-option__bg: var(--sbkSelectColorBgColorOnLightFlyoutEnabled);
  --_select-option__bg--active: var(--sbkSelectColorBgColorOnLightFlyoutActive);
`;
